// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-device-width: 768px) {
  form button {
    width: auto;
  }
}
.reset-phone-text {
  max-width: 300px;
}

.mobile-container {
  min-height: 5rem;
}
@media only screen and (max-device-width: 768px) {
  .mobile-container {
    min-height: 6rem;
  }
}

.message-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.message-container .verification-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 274px;
}
.message-container .verification-container h4 {
  text-align: left;
}
.message-container .verification-container .custom-row {
  display: flex;
  text-align: center;
  align-items: center;
}
.message-container .verification-container .custom-row .icon-container {
  display: flex;
  flex-direction: column;
}
.message-container .code-receiver-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  line-height: 20px;
  padding: 10px 0px 5px;
  width: 274px;
}
.message-container .code-receiver-container a {
  display: flex;
  margin-left: auto;
}

.custom-row {
  line-height: 20px;
  display: flex;
  padding: 10px 0px;
}
.custom-row p {
  text-align: justify;
  padding-left: 5px;
}

.padding-bottom-5 {
  padding-bottom: 5px;
  align-self: flex-start;
}

a {
  cursor: pointer;
}

h4 {
  font-weight: 900;
}

p,
h3,
h4 {
  margin: 0 !important;
}

p.spacer-5 {
  margin-top: 5px !important;
}

ion-icon[name*=alert-circle-outline] {
  color: #d0021b;
  font-size: 1em;
}
ion-icon[name*=lock] {
  color: green;
  height: 2.5em;
  width: 2.5em;
}

.input-icon-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
.input-icon-icon ion-icon {
  font-size: 2rem;
  align-items: center;
}

ion-grid {
  margin: 0px 80px;
}
@media screen and (max-width: 576px) {
  ion-grid {
    margin: 10px;
  }
}
ion-grid ion-list {
  padding: 0px;
}
ion-grid .password-container .password-input {
  width: 274px;
}
ion-grid .resend-class {
  display: inline-flex;
  width: 274px;
}
ion-grid .code-sent-row {
  display: grid;
  justify-content: center;
}
ion-grid .text-box-row {
  display: grid;
  justify-items: center;
}
ion-grid .resend-code-msg {
  background: transparent;
  border: 1px solid var(--ion-color-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/authenticator/verify-sms/verify-sms.component.scss"],"names":[],"mappings":"AAAA;EAEM;IACE,WAAA;EAAN;AACF;AAIE;EACC,gBAAA;AAFH;;AAKE;EAIE,gBAAA;AALJ;AAEI;EADF;IAEI,gBAAA;EACJ;AACF;;AAGE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAAJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AACN;AAAM;EACE,gBAAA;AAER;AAAM;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;AAER;AADQ;EACE,aAAA;EACA,sBAAA;AAGV;AAEI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;AAAN;AACM;EACE,aAAA;EACA,iBAAA;AACR;;AAIE;EACE,iBAAA;EACA,aAAA;EACA,iBAAA;AADJ;AAEI;EACE,mBAAA;EACA,iBAAA;AAAN;;AAIE;EACE,mBAAA;EACA,sBAAA;AADJ;;AAIE;EACE,eAAA;AADJ;;AAIE;EACE,gBAAA;AADJ;;AAIE;;;EAGE,oBAAA;AADJ;;AAIE;EACE,0BAAA;AADJ;;AAKI;EACE,cAAA;EACA,cAAA;AAFN;AAKI;EACE,YAAA;EACA,aAAA;EACA,YAAA;AAHN;;AAOE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAJJ;AAKI;EACE,eAAA;EACA,mBAAA;AAHN;;AAOE;EACE,gBAAA;AAJJ;AAKI;EAFF;IAGI,YAAA;EAFJ;AACF;AAII;EACE,YAAA;AAFN;AAMM;EACE,YAAA;AAJR;AAQI;EACE,oBAAA;EACA,YAAA;AANN;AASI;EACE,aAAA;EACA,uBAAA;AAPN;AAUI;EACE,aAAA;EACA,qBAAA;AARN;AAWI;EACE,uBAAA;EACA,4CAAA;AATN","sourcesContent":["@media only screen and (max-device-width: 768px) {\r\n    form {\r\n      button {\r\n        width: auto;\r\n      }\r\n    }\r\n  }\r\n  \r\n  .reset-phone-text {\r\n   max-width: 300px;\r\n  }\r\n  \r\n  .mobile-container {\r\n    @media only screen and (max-device-width: 768px) {\r\n      min-height: 6rem;\r\n    }\r\n    min-height: 5rem;\r\n  }\r\n  \r\n  .message-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    .verification-container {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      width: 274px;\r\n      h4 {\r\n        text-align: left;\r\n      }\r\n      .custom-row {\r\n        display: flex;\r\n        text-align: center;\r\n        align-items: center;\r\n        .icon-container {\r\n          display: flex;\r\n          flex-direction: column;\r\n        }\r\n      }\r\n    }\r\n  \r\n    .code-receiver-container {\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: center;\r\n      align-items: center;\r\n      line-height: 20px;\r\n      padding: 10px 0px 5px;\r\n      width: 274px;\r\n      a {\r\n        display: flex;\r\n        margin-left: auto;\r\n      }\r\n    }\r\n  }\r\n  \r\n  .custom-row {\r\n    line-height: 20px;\r\n    display: flex;\r\n    padding: 10px 0px;\r\n    p {\r\n      text-align: justify;\r\n      padding-left: 5px;\r\n    }\r\n  }\r\n  \r\n  .padding-bottom-5 {\r\n    padding-bottom: 5px;\r\n    align-self: flex-start;\r\n  }\r\n  \r\n  a {\r\n    cursor: pointer;\r\n  }\r\n  \r\n  h4 {\r\n    font-weight: 900;\r\n  }\r\n  \r\n  p,\r\n  h3,\r\n  h4 {\r\n    margin: 0 !important;\r\n  }\r\n  \r\n  p.spacer-5 {\r\n    margin-top: 5px !important;\r\n  }\r\n  \r\n  ion-icon {\r\n    &[name*=\"alert-circle-outline\"] {\r\n      color: #d0021b;\r\n      font-size: 1em;\r\n    }\r\n  \r\n    &[name*=\"lock\"] {\r\n      color: green;\r\n      height: 2.5em;\r\n      width: 2.5em;\r\n    }\r\n  }\r\n  \r\n  .input-icon-icon {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    ion-icon {\r\n      font-size: 2rem;\r\n      align-items: center;\r\n    }\r\n  }\r\n  \r\n  ion-grid {\r\n    margin: 0px 80px;\r\n    @media screen and (max-width: 576px) {\r\n      margin: 10px;\r\n    }\r\n  \r\n    ion-list {\r\n      padding: 0px;\r\n    }\r\n  \r\n    .password-container {\r\n      .password-input {\r\n        width: 274px;\r\n      }\r\n    }\r\n  \r\n    .resend-class {\r\n      display: inline-flex;\r\n      width: 274px;\r\n    }\r\n  \r\n    .code-sent-row {\r\n      display: grid;\r\n      justify-content: center;\r\n    }\r\n  \r\n    .text-box-row {\r\n      display: grid;\r\n      justify-items: center;\r\n    }\r\n  \r\n    .resend-code-msg {\r\n      background: transparent;\r\n      border: 1px solid var(--ion-color-secondary);\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
